import { FC } from 'react';
import { Close } from '@mui/icons-material';
import { Alert, AlertTitle, IconButton, Snackbar } from '@mui/material';

type Props = {
  onClose: () => void;
  open: boolean;
};

const MessageComposerNetworkErrorBanner: FC<Props> = ({ onClose, open }) => (
  <Snackbar
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    open={open}
    onClose={onClose}
  >
    <Alert
      severity="error"
      action={
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      }
    >
      <AlertTitle>No internet connection.</AlertTitle>
      You will be able to send messages once you are back online.
    </Alert>
  </Snackbar>
);

export { MessageComposerNetworkErrorBanner };
